export class GlobalConstants {
  public static apiURL: string = "https://crmapi.glamyo.in/api/v1/";
  public static openApiURL: string = "https://crmapi.glamyo.in/api/";
  // public static apiURL: string = "http://localhost:8000/api/v1/";
  // public static openApiURL: string = "http://localhost:8000/api/";
  public static appVersion: string = '0.0.1';


  //Here we are defining sheet view column number and column start from Zero (0).
  public static sheetColumns = {
    status: 27,
    description: 21
  }
}
